import React from 'react';
import Navbar1 from '../Components/Navbar1';
import Form from 'react-bootstrap/Form';
import { FlexColumnContainer } from '../Containers';
import { HeaderText1 } from '../Components/Text';
import { TransparentButton } from '../Components/Button';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {Link, useNavigate} from 'react-router-dom';
import {Formik} from 'formik'
import { QuestionSchema } from '../Validator/questionSchema';
import ROUTES from '../Navigation/routes';
import { useState } from 'react';

const UploadScreen = () => {
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);

  const uploadQuestion = async(question,opt1,opt2,opt3,ans) =>{

    fetch('https://hnc-app.herokuapp.com/v1/loadquestion', 
    { method: 'POST',
      body: JSON.stringify({
        question: question,
        optionA: opt1,
        optionB: opt2,
        optionC: opt3,
        correct: ans
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8"
    }
    }).then(response => {

      console.log(response.status)
      
      if(response.status === 200){

        return { success: true }
      }
    });

  }

  return (
    <div>
        <Navbar1/>
        <Container>
        <FlexColumnContainer>
            <HeaderText1>Upload Question of the week</HeaderText1>
        </FlexColumnContainer>
        <Form>
      <Formik 
             initialValues={{
              question: '',
              option1: '',
              option2: '',
              option3: '',
              correct: ''
            }}
            validationSchema={QuestionSchema}
            onSubmit={async( values, {setErrors})=>{

              setLoading(true);

              
             const upload = await uploadQuestion(values.question, values.option1, values.option2, values.option3, values.correct);
             
             console.log(upload);

             if(upload.success){
               navigate(ROUTES.SUBMITTED);
               setLoading(false);

             }else{

              setLoading(false);
              setErrors({question: upload?.error});

             }

              
            }
          }
        >
          {({errors, handleChange, handleSubmit, values, handleBlur, isValid})=>(
            <>
        <Form.Group as={Row} className="mb-3" controlId="formBasicEmail">
          <Col md="12" sm='12'lg='12' xs='12'>
          <Form.Control as="textarea" rows={3}
            type="text"
            placeholder="Question"
            onChange={handleChange('question')}
            value={values.question}
           />
           <p style={{color: 'red'}}>{errors.question}</p>
          </Col>
        </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="formBasicPassword">

            <Col md="6" sm='6'lg='6' xs='8'>
            <Form.Control 
              type="text"
              placeholder="option1"
              onChange={handleChange('option1')}
              value={values.option1}
               />
              <p style={{color: 'red'}}>{errors.option1}</p>
            </Col>

            <Col md="6" sm='6'lg='6' xs='8'>
                <Form.Control 
                  type="text"
                  placeholder="option2"
                  onChange={handleChange('option2')}
                  value={values.option2}
                  />
                  <p style={{color: 'red'}}>{errors.option2}</p>
            </Col>

          </Form.Group>
          
          <Form.Group as={Row} className="mb-3" controlId="formBasicCheckbox">
            <Col md="6" sm='6'lg='6' xs='8'>
                <Form.Control 
                  type="text"
                  placeholder="option3"
                  onChange={handleChange('option3')}
                  values={values.option3} 
                  />
                  <p style={{color: 'red'}}>{errors.option3}</p>
            </Col>

            <Col md="6" sm='6'lg='6' xs='8'>
                    <Form.Control 
                      type="text"
                      placeholder="Correct Answer"
                      onChange={handleChange('correct')}
                      value={values.correct} />
                      <p style={{color: 'red'}}>{errors.correct}</p>
            </Col>
          </Form.Group>
        
          <FlexColumnContainer mt='20px'>
                    {isLoading ? <TransparentButton variant="primary"
                     text='Submitting... Please wait'
                     enabled='false'/> : <TransparentButton variant="primary"
                     text='Submit'
                     onClick={handleSubmit}/>}
            {/* <TransparentButton variant="primary" type="submit" text='Submit'/> */}
          </FlexColumnContainer>
          </>
          )}
      </Formik>
    </Form>
    </Container>
    </div>
  )
}

export default UploadScreen